const MSA_TOKEN = "msaToken";
const TURF_TOKEN = "turfToken";

const STATUS_TYPES = {
  INVITED: "Invited",
  REGISTERED: "Registered",
};
const APPLICATION_ID = "applicationId";

const USER_DATA = "userInfo";

const USER_ID = "userId";

const CREDIT_CARD = "isCardConnected";

const CASH_APP = "isCashAppConnected";

const PAYPAL = "isPayPalConnected";

const STRIPE = "stripe";

const ZELLE = "zelle";

const COMPLETED_TASKS = "completedTasks";

const INSTALL_PROMPT = "installPrompt";

export {
  MSA_TOKEN,
  STATUS_TYPES,
  TURF_TOKEN,
  APPLICATION_ID,
  USER_DATA,
  USER_ID,
  CREDIT_CARD,
  CASH_APP,
  PAYPAL,
  STRIPE,
  COMPLETED_TASKS,
  ZELLE,
  INSTALL_PROMPT,
};
